import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DiscountOfferItemsFilterEntity } from '../../domain/entities/DiscountOfferItemsFilterEntity'
export class DiscountOfferItemsFilterModel extends DiscountOfferItemsFilterEntity {
  id: number = 0
  constructor(dataDto: DiscountOfferItemsFilterEntity) {
    super()
    mapEntityProperties<DiscountOfferItemsFilterEntity>(this, dataDto)
  }
}
 